export default {"src":"/_next/static/media/Vector-2-gradient.fd9eb74d.svg","height":273,"width":172,"blurWidth":0,"blurHeight":0};